import React, { ReactNode, ReactNodeArray } from 'react';

interface IProps {
  children: ReactNode | ReactNodeArray;
}

function TabList({ children }: IProps) {
  return (
    <div className="novoTabList" role="tablist">
      {children}
    </div>
  );
}

export default TabList;
